export default "__VITE_ASSET__Bo6a5NJP__"